import { render, staticRenderFns } from "./DocumentSelectionPage.vue?vue&type=template&id=980536ce&scoped=true"
import script from "./DocumentSelectionPage.vue?vue&type=script&lang=js"
export * from "./DocumentSelectionPage.vue?vue&type=script&lang=js"
import style0 from "./DocumentSelectionPage.vue?vue&type=style&index=0&id=980536ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980536ce",
  null
  
)

export default component.exports